export class Industry {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
